module.exports = __webpack_public_path__ + "img/icon-multi.b1b764e2.svg";